export default __webpack_public_path__ + "static/media/Jack_of_diamonds.5734776d.svg";